import React, { useState } from 'react'
import moment, { Moment } from 'moment'
import {sprintf} from 'sprintf-js'

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import Button from '@mui/material/Button'

import './App.css'

function App() {
  const calConfig = window.calConfig !== undefined ? window.calConfig :
    {
      "start": { "seconds": 0, "minutes": 0, "hours": 0, "mday": 1, "wday": 0, "mon": 5, "year": 2022, "yday": 120, "weekday": "Sunday", "month": "May", "0": 1651363200 },
      "end": { "seconds": 0, "minutes": 0, "hours": 0, "mday": 30, "wday": 4, "mon": 8, "year": 2022, "yday": 180, "weekday": "Thursday", "month": "June", "0": 1656547200 },
      "rates": { "2022-06-17": "200" },
      "taken": {  "2022-05-30": "2022-06-05" }
    }

  const [startDate, setStartDate] = useState<Moment>(moment())

  const mvNext = () => setStartDate(s => s.clone().add(1, 'month'));
  const mvPrev = () => setStartDate(s => s.clone().subtract(1, 'month'));

  const startOfCalendar = startDate.clone().startOf('month').startOf('week')
  const endOfCalendar = startDate.clone().endOf('month').endOf('week')

  const prevDisabled: boolean = startOfCalendar.isSameOrBefore(moment.unix(calConfig.start[0]))
  const nextDisabled: boolean = endOfCalendar.isSameOrAfter(moment.unix(calConfig.end[0]))

  const getWeekRate = (date: Moment): number => {
    const weekEnd = date.clone().endOf('week')
    for (const rWeek in calConfig.rates)
      if (weekEnd.isSame(rWeek, 'date'))
        return calConfig.rates[rWeek];
    return 0
  }

  const isDateAvailable = (date: Moment): string => {
    const weekEnd = date.clone().endOf('week')
    for (const rWeek in calConfig.rates) {
      if (weekEnd.isSame(rWeek, 'date') && calConfig.rates[rWeek] === 0)
        return 'unavailable'
    }
    for (const start in calConfig.taken) {
      if (date.isBetween(start, calConfig.taken[start], undefined, '[]')) return 'taken'
    }
    return 'available'
  }

  let output = <></>
  let row = <></>
  let rowUnaCount = 0
  for (let curDate = startOfCalendar.clone(); curDate.isBefore(endOfCalendar); curDate.add(1, 'd')) {
    if (curDate.day() === 0) rowUnaCount = 0
    const wkRate = getWeekRate(curDate)
    const dayStatus = wkRate !== 0 ? isDateAvailable(curDate) : 'unavailable'
    const isWrongMonth = !curDate.isSame(startDate, 'month')

    rowUnaCount += dayStatus === 'available' ? 1 : 0

    const dayStyle = ['caldate', 'txtcenter', isWrongMonth ? 'wrongMonth' : dayStatus].join(' ')
    row = <>{row}<td className={dayStyle}>{curDate.format('DD')}</td></>
    if (curDate.day() === 6) {
      if (rowUnaCount === 7 && wkRate !== 0)
        row = <>{row}<td className={'txtcenter rate'}>{sprintf( '%1$.0f', wkRate)}</td></>
      else if (wkRate === 0)
        row = <>{row}<td className={'txtcenter rate unavailable'}>NA</td></>
      else if (rowUnaCount === 0)
        row = <>{row}<td className={'txtcenter rate'}>-</td></>
      else
        row = <>{row}<td className={'txtcenter rate'}>{sprintf( '%1$.0f', wkRate)}</td></>

      output = <>{output}<tr>{row}</tr></>
      row = <></>
    }
  }

  return (
    <div className="App-header">
      <table className="ctbl">
        <tbody>
          <tr>
            <td colSpan={2}><Button disabled={prevDisabled} onClick={mvPrev} startIcon={<ArrowLeftIcon />}>Previous</Button></td>
            <td style={{ textAlign: 'center' }} colSpan={4}>{startDate.format('MMM YYYY')}</td>
            <td style={{ textAlign: 'right' }} colSpan={2}><Button disabled={nextDisabled} onClick={mvNext} endIcon={<ArrowRightIcon />}>Next</Button></td>
          </tr>
          <tr>
            <td className={'txtcenter'} width={'12%'}>Sun</td>
            <td className={'txtcenter'} width={'12%'}>Mon</td>
            <td className={'txtcenter'} width={'12%'}>Tue</td>
            <td className={'txtcenter'} width={'12%'}>Wed</td>
            <td className={'txtcenter'} width={'12%'}>Thr</td>
            <td className={'txtcenter'} width={'12%'}>Fri</td>
            <td className={'txtcenter'} width={'12%'}>Sat</td>
            <td className={'txtcenter'} width={'16%'}>&pound;pw</td>
          </tr>
          {output}
        </tbody>
      </table>
    </div>
  );
}

export default App;
